import { PersonAdd } from '@mui/icons-material';
import Page from 'components/new/Page';
import TabsPanel from 'further-ui/components/TabsPanel';
import Overview from './Overview';
import OnboardingSettings from './OnboardingSettings';
import DocumentSigning from './DocumentSigning/ListDocuments';
import { useLayoutContext } from 'contexts/LayoutContext';
import PageLoader from 'components/PageLoader';
import DataRoomSetup from './DataRoomSetup';
import ErrorBoundary from 'components/ErrorBoundary';

const ADD_DATA_ROOM = '#';

const Onboarding: React.FC = () => {
  const { selectedVehicleId } = useLayoutContext();

  if (!selectedVehicleId) {
    return <PageLoader />;
  }

  const tabs = [
    {
      key: 'overview',
      label: 'Overview',
      content: <Overview />,
      urlParam: 'overview',
    },
    {
      key: 'data-room',
      label: 'Data room setup',
      content: <DataRoomSetup />,
      urlParam: 'data-room',
    },
    {
      key: 'document-signing',
      label: 'Document signing',
      content: <DocumentSigning />,
      urlParam: 'document-signing',
    },
    {
      key: 'settings',
      label: 'Settings',
      content: <OnboardingSettings vehicleId={selectedVehicleId} />,
      urlParam: 'settings',
    },
  ];

  return (
    <Page
      heading="Onboarding"
      headingIcon={PersonAdd}
      spacing="sm"
      actions={[
        {
          label: 'Add data room',
          link: ADD_DATA_ROOM,
          variant: 'contained',
        },
      ]}
    >
      <ErrorBoundary loader={<PageLoader />}>
        <TabsPanel useTabsUrls tabs={tabs} />
      </ErrorBoundary>
    </Page>
  );
};

export default Onboarding;
